export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
    login: {
      signUp:'Εγγραφείτε',  
      title: 'Καθολικό πορτοφόλι για όλα τα ψηφιακά σας στοιχεία.',
      submit: 'Σύνδεση',
      username: 'Εισαγάγετε τον αριθμό τηλεφώνου σας ',
      password: 'Παρακαλώ εισάγετε τον κωδικό σας',
      verifycode:'Εισαγάγετε captcha ',
      forget_password:'Ξεχάσατε τον κωδικό σας; ',
	  no_account:'Δεν έχετε λογαριασμό AuWallet; ',
      register:'Εγγραφείτε ',
      verifycode_tip:'παρακαλώ εισάγετε captcha ',
      verifycode_error:'Μη έγκυρο captcha '
    },
    register:{
      title:'Εγγραφείτε ',
      username:'Τηλεφωνικό νούμερο',
      get_code:'Πάρετε τον κωδικό ',
      verifycode:'Κωδικός επαλήθευσης ',
      password:'Κωδικός πρόσβασης',
      repeat:'Επιβεβαιώνω ',
      invite_code:'Κώδικας πρόσκλησης',
      submit:'Εγγραφείτε ',
      registered:'Έχω ήδη λογαριασμό ',
      go_login:'Μετάβαση Είσοδος '
    },
    nologin:{
      cloud_wallet:'πορτοφόλι σύννεφο',
      cloud1:'Κορυφαία προστασία ασφαλείας',
      cloud2:'Μοναδικό κέρδος περιουσιακών στοιχείων, εγγραφείτε και καταθέστε νομίσματα για να απολαύσετε το εισόδημα ',
      cloud3:'Υποστηρίξτε περισσότερα από 30+ κυρίαρχο ρεύμα νομίσματα και 500+ τοκεν',
      button1:'Εγγραφείτε ',
      button2:'Σύνδεση',
      button_oauth: 'Συνδεθείτε με το 2U.Chat',
      hd_wallet:'Πορτοφόλι HD ',
      hd1:'100% έλεγχος των ιδιωτικών κλειδιών, πιο ασφαλή περιουσιακά στοιχεία ',
      hd2:'Εισαγωγή μνημονικών λέξεων με ένα κλικ, βολικό και εύκολο στη χρήση ',
      hd3:'Υποστηρίξτε περισσότερα από 30+ κυρίαρχο ρεύμα νομίσματα και 500+ τοκεν',
      button3:'Εγγραφείτε',
      button4:'Σύνδεση',
      doLogin:"Κάντε κλικ για να συνδεθείτε",
      welcomeTo:"Καλώς ήρθατε στο AuWallet",
    },
    forget:{
      title:'Ξεχάσατε τον κωδικό πρόσβασης; ',
      phone_number:'Τηλεφωνικό νούμερο',
      verify_code:'Κωδικός επαλήθευσης ',
      password:'Κωδικός πρόσβασης',
      repeat:'Επανάλαβε ',
      submit:'Επιβεβαιώνω '
    },
    footer:{
      nav1:'πορτοφόλι',
      nav2:'αγορά',
      nav3:'επενδυτικά αγαθά ',
      nav4:'ανακάλυψη',
      nav5:'μου' 
    },
    home:{
      total:'σύνολο επενδυτικά αγαθά ',
      invite:'Προσκαλέσετε τους φίλους',
      redbag:'Αποστολή κόκκινου πακέτου ',
      exchange:'Ανταλλαγή',
      scan:'Σάρωση',
      address_book:'Βιβλίο διευθύνσεων',
      notice:'Ειδοποιήσεις',
      setting:'Ρυθμίσεις',
      view_mnemonic:'προβολή Μνημονικός ',
      backup_mnemonic:'ενισχύσεις Μνημονικός ',
      create_wallet:'Δημιουργία Πορτοφολιού ',
      import_wallet:'Εισαγωγή Πορτοφολιού', 
      welcome:'καλως ΗΡΘΑΤΕ',
	  cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
    },
    
    address:{
      new_address:'Νέα διεύθυνση ',
      name:'Ονομα',
      address:'Διεύθυνση',
      submit:'Δημιουργώ',
	  warning_msg: 'Σημείωση: αυτή η διεύθυνση μπορεί να λάβει μόνο μάρκες Παρακαλούμε προσέξτε να μην επιλέξετε λάθος κανάλι κατά τη μεταφορά.'
    },
    swap:{
      title:'Flash Swap',
      pay:'Θα πρέπει να πληρώσετε ',
      balance:'διαθέσιμο υπόλοιπο',
      lock_rate:'Ολοκληρώστε την πληρωμή εντός του επόμενου χρόνου για να κλειδώσετε αυτήν την ισοτιμία ',
      gain:'Θα πάρεις ',
      input:'Εισαγάγετε το ποσό ',
      tip:'Όταν το νόμισμα που λαμβάνετε είναι κενό, αυτό σημαίνει ότι δεν υπάρχει νόμισμα για flash swap ',
      submit:'Ανταλλάξτε τώρα ',
      choose_coin:'Επιλέξτε Κέρμα ',
	  notice_2ut:'διάβασα αυτή την ανακοίνωση'
    },
    coin:{
      send:'Στείλετε ',
      swap:'Ανταλαγή ',
      receive:'Λαμβάνω ',
      transactions:'Συναλλαγές ',
      type1: 'Cloud Εξω',
      type2: 'Cloud Σε',
      type3: 'Ανταλλαγή',
      type4: 'Οικονομικά',
      type7: 'Εξοδος HD',
      type8: 'HD Σε',
      type9: "Αποστολή κόκκινου πακέτου",
      type10: "Αποδοχή κόκκινου πακέτου",
	  type11:'AuWallet transfer out TimeEx',
	  type12:'TimeEx transfer in AuWallet',
	  type13: 'Chain shopping service fee',
	  type14: '10% Off shopping service fee',
	  type15: 'Withdrawal',
      flushing:'Έξαψη...',
      loading:'Φόρτωση...',
      no_records:'Δεν υπάρχουν εγγραφές',
      wallet: 'Πορτοφόλι',
      tx_time:'Transaction Time',
      tx_id:'ID',
      tx_from:'Από',
      tx_to:'Προς',
      tx_memo:'Σημείωση',
      tx_status1:'αποτυχία',
      tx_status2:'waiting',
      tx_status3: 'επιτυχία',
      tx_status4:'εκκρεμεί', 
  
      receive_address:'Εισαγάγετε τη διεύθυνση λήψης',
      balance:'Ισορροπία',
      fee:'τέλη',
      send_all:'Στείλε τα όλα',
      gas_fee:'Τέλος φυσικού αερίου',
      slow:'αργός',
      fast:'γρήγορα',
      send:'Στείλετε',
      tx_password:'Εισαγάγετε τον κωδικό πληρωμής',
      tx_remark:'Παρατηρήσεις (προαιρετικά) ',
      address_book1:'Βιβλίο διευθύνσεων Cloud ',
      address_book2:'Βιβλίο διευθύνσεων HD',
      need_pay_pass:'Ορίστε πρώτα τον κωδικό πληρωμής',
      need_pin:'Μεταβείτε στο προσωπικό κέντρο για να ορίσετε τον κωδικό PIN',
  
      
      set_receive_amount:'Ορίστε το ποσό λήψης',
      receive_amount:'Λήψη ποσού',
      copy_receive_code:'Αντιγράψτε τον κωδικό πληρωμής',
      confirm:'Επιβεβαιώνω ',
      cancel:'Ματαίωση',
      rcv_address:'Διεύθυνση παραλαβής',
      search:'Εισαγάγετε περιεχόμενο αναζήτησης',
      filter:'Φίλτρο',
      remove:'Αφαιρώ',
      add:'Προσθήκη',
  
      filter1:'Όλα τα νομίσματα',
      filter2:'Προστέθηκε',
      filter3:'Δεν προστέθηκε', 
      
      notices:'Ειδοποιήσεις πορτοφολιού HD',
      notices2:'Ειδοποιήσεις πορτοφολιού Cloud',
	  only_bitcoin: 'Μόνο συναλλαγή bitcoin εδώ',
	  only_eth: 'Μόνο συναλλαγή ETH εδώ',
	  only_usdt: 'Μόνο συναλλαγή USDT ERC20 εδώ',
	  only_2ut: 'Μόνο 2UT συναλλαγή εδώ',
	  only_u2u: 'Μόνο νόμισμα u2u',
	  only_2u: 'Μόνο σημείο 2U',
	  only_a2u: 'μεταφορά a2u μόνο',
	  import: 'Import',
	  info: 'Token overview'
    },
  
    market:{
      title:'Αγορά',
      coin:'επενδυτικά αγαθά',
      volume:'όγκος',
      price:'τιμή',
      change:'αλλαγή(24 ώρες)',
    },
  
    discover:{
      title:'Ανακαλύπτω',
      popular:'Δημοφιλής',
      all:'Ολα'
    },
  
    my:{
      title:'Μου',
      notice:'Ειδοποιήσεις',
      login:'Κάντε κλικ για να συνδεθείτε',
      welcome:'Καλώς ήρθατε στο AuWallet',
      invite:'Επιβράβευση πρόσκλησης',
      news:'Καθημερινά ξπρές',
      contact:'Εξυπηρέτηση πελατών ',
      pin_on:'εντός',
      pin_off:'εκτός',
      default_currency:'Προεπιλεγμένο νόμισμα',
      red_green:'Επιλογές προσφοράς',
      option1:'Πράσινο επάνω κόκκινο προς τα κάτω',
      option2:'Κόκκινο πάνω πράσινο κάτω',
      contract:'Σύμβαση παροχής υπηρεσιών',
      privacy:'Πολιτική Απορρήτου',
      help:'Κέντρο βοηθείας',
		invite: 'My Invite code',
		onequan: 'My Business Circle',
		copy: 'Copy',
		total: 'Total',
		downloadapp: 'Download mobile APP.',
		download: 'Download',
		waiting: 'Waiting Or Use',
		reenxv: 'GreenX Vcode',
		greenxvet: 'Can use'
    },
    setup:{
      title:'Ρύθμιση πορτοφολιού',
      pay_password:'Κωδικός πληρωμής',
      on:'εντός',
      off:'εκτός',
      google:"Επαλήθευση Google",
      security_level:'Επίπεδο ασφαλείας',
      account_name:'Όνομα λογαριασμού',
      logout:'Αποσύνδεση',
      register_time:'Ώρα εγγραφής',
      level:'επίπεδο',
      modify_pay_password:'Τροποποίηση κωδικού πρόσβασης πληρωμής',
      reset_pay_password:'Επαναφορά κωδικού πρόσβασης πληρωμής',
      reset_tip:'Για την ασφάλεια του λογαριασμού σας, εισαγάγετε τον αρχικό κωδικό πληρωμής για να επιβεβαιώσετε την ταυτότητά σας',
      forget_pay_password:'Ξέχασα τον κωδικό πληρωμής',
      set_pay_password:'Ορισμός κωδικού πρόσβασης πληρωμής',
      enter_password:'Παρακαλώ εισάγετε τον κωδικό πρόσβασης',
      enter_password2:'Παρακαλώ εισάγετε ξανά',
      vcode: "Κωδικός επαλήθευσης",
      submit: "Επιβεβαίωση" ,
    pay_password_wrong:'Ο κωδικός πρόσβασης που εισαγάγατε είναι λάθος',
    fontSize:'Μέγεθος γραμματοσειράς'

    },
    news:{
      title:'Kαθημερινή Εξπρές ',
      share:'Μερίδιο',
      good:'Καλός',
      bad:'Κακό',
    },
    pin:{
      title:'Ορισμός κωδικού PIN ',
      desc1:'Για να προστατεύσετε την ασφάλεια των περιουσιακών σας στοιχείων, ορίστε πρώτα έναν κωδικό PIN, ο κωδικός PIN θα χρησιμοποιηθεί για να ξεκλειδώσετε το πορτοφόλι και να στείλετε νομίσματα ',
      desc2:'Ο κωδικός PIN είναι ένας τοπικός κωδικός πρόσβασης, διατηρήστε τον σωστά, εάν χαθεί, δεν μπορεί να ανακτηθεί',
      close:'Απενεργοποιήστε τον κωδικό PIN',
      title2:'Επαλήθευση PIN',
      tip2_1:'Ξεχάσατε τον κωδικό PIN; Αφού δημιουργήσετε αντίγραφα ασφαλείας του πορτοφολιού, εγκαταστήστε ξανά την εφαρμογή και πραγματοποιήστε επαναφορά μετά την εισαγωγή της μνημονικής φράσης '
    },
    google:{
      title:'Επαλήθευση Google ',
      tip:'Η επαλήθευση σε δύο βήματα της Google μπορεί να προσθέσει ένα επίπεδο προστασίας στον λογαριασμό σας. Όταν συνδέεστε ή πραγματοποιείτε μια συναλλαγή, όταν εισάγετε τον κωδικό πρόσβασής σας, χρειάζεστε επίσης έναν κωδικό επαλήθευσης από επαλήθευση δύο βημάτων ',
      help:'Πώς να χρησιμοποιήσετε την επαλήθευση δύο βημάτων Google ',
    },
    security:{
      title:'Επίπεδο ασφαλείας',
      title2:'Επίπεδο ασφαλείας',
      tip:'Για την ασφάλεια των κεφαλαίων σας, χρειάζεστε περαιτέρω ρυθμίσεις ασφαλείας και πληροφορίες πραγματικού ονόματος για να μπορέσετε να κάνετε ανάληψη νομισμάτων και το όριο ανάληψης θα αυξηθεί αναλόγως ',
      l3title:'Επιλέξτε τύπο εγγράφου',
      l3tip:'Επιλέξτε τη χώρα έκδοσης του πιστοποιητικού σας',
      c1:'Αμερική',
      c2: 'Ηπειρωτική Κίνα',
      c3: 'Κίνα Χονγκ Κονγκ, Μακάο και Ταϊβάν',
      c4: 'Νότια Κορέα',
      c5: 'Ιαπωνία',
      c6: 'Σιγκαπούρη',
      c7: 'Άλλο', 
      nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
    },
    realname:{
      title:'Πληροφορίες Πιστοποίησης',
      tip:'Το AuWallet απαιτεί να υποβάλετε μια ταυτότητα με φωτογραφία που έχει εκδοθεί από την κυβέρνηση για να περάσετε την επαλήθευση ασφαλείας',
      subtitle1:'Φόρμα συνδρομής 2U Token (2UT)',
      country:'Χώρα',
      country_hint:'Χώρα κατοικίας',
      firstname:'Ονομα',
      firstname_hint:'Το όνομά σας ',
      surname:'Επώνυμο ',
      surname_hint:'Το επίθετό σου ',
      birthdate:'Γενέθλια ',
      cert_id:'Αριθμό ταυτότητας ',
      cert_id_hint:'Ο αριθμός ταυτότητάς σας ',
      id_photo1:'Μπροστινή φωτογραφία ταυτότητας ',
      id_photo2:'Ανάποδη φωτογραφία ταυτότητας ',
      address:'Διεύθυνση',
      address_hint:'Η τρέχουσα κατοικία σας',
      addr_photo:'Αποδεικτικό διεύθυνσης κατοικίας ',
      asset_photo:'Απόδειξη περιουσιακών στοιχείων ',
      subtitle2:'Πιστοποίηση προσόντων επενδυτών ',
      tip1:'Επιβεβαιώνω ότι πληρώ τουλάχιστον ένα από τα ακόλουθα κριτήρια και ότι έχω πιστοποιηθεί ως πιστοποιημένος επενδυτής από τον εκδότη (εάν ισχύει, μπορούν να επιλεγούν περισσότερα από ένα) ',
      tip2:'Σημείωση (1): Το επενδυτικό χαρτοφυλάκιο αφορά τίτλους και μετρητά, εξαιρουμένων των ακινήτων. ',
      tip3:'Σημείωση (2): Τα έγγραφα που έχουν μηνιαίο εκκαθαριστικό, περίληψη υπολογισμού κ.λπ. πρέπει να επισυνάπτονται τους τελευταίους τρεις μήνες ',
      invest_exp:'Επενδυτική εμπειρία ',
      other_exp:'Αλλα',
      avg_volume:'όγκος',
      avg_volume_hint:'Μέσος όγκος συναλλαγών τους τελευταίους 12 μήνες (USD)',
      avg_num:'Αριθμός',
      avg_num_hint:'Μέσος αριθμός συναλλαγών τους τελευταίους 12 μήνες ',
      exp_year:'Επενδυτικά έτη',
      exp_year_hint:'Πόσα χρόνια επενδυτική εμπειρία ',
      net_asset:'Καθαρό ενεργητικό',
      net_asset_hint:'Καθαρή Αξία Ενεργητικού (USD)',
      risk_tolerance:'Ανοχή ρίσκου',
      invest_term:'Ιδανικός επενδυτικός όρος ',
      derivative:'Παράγωγα ',
      signature:'Υπογραφή',
      reset:'Επαναφορά ',
      phone_number:'Τηλεφωνικό νούμερο ',
      submit:'υποβάλλουν ',
      option1_1: 'Μεμονωμένοι ή ιδιώτες επενδυτές υψηλής καθαρής αξίας με χαρτοφυλάκιο μετρητών ή/και τίτλων τουλάχιστον 20.000 $ ΗΠΑ (ή ισοδύναμο) σε κοινό λογαριασμό με τη σύζυγο ή τα παιδιά τους',
       option1_2: 'Το επενδυτικό χαρτοφυλάκιο της εταιρείας ή της εταιρικής σχέσης δεν είναι μικρότερο από 20.000 $ ΗΠΑ ή το συνολικό ενεργητικό δεν είναι μικρότερο από 2 εκατομμύρια $ ΗΠΑ',
       option1_3: 'Μεμονωμένοι επενδυτές ή εταιρείες ή συνεργασίες υψηλής καθαρής αξίας ανοίγουν λογαριασμό στην De La O RuralBank Inc. και έχουν τουλάχιστον 20.000 USD κατά τη στιγμή της υπογραφής αυτού του εντύπου αξιολόγησης',
       option2_1:'Τίτλοι',
       option2_2:'Μελλοντικά',
       option2_3:'Τοποθέτηση',
       option2_4:'Άλλο (παρακαλώ προσδιορίστε)',
       option3_1:'Υψηλή',
       option3_2:'Μεσαίο',
       option3_3:'Χαμηλό',
       option4_1:'Περισσότερα από 3 χρόνια',
       option4_2: '1-3 χρόνια',
       option4_3:'Λιγότερο από 1 έτος',
       option5_1: 'Ναι',
       option5_2:'Όχι' 
    },
    envelope:{
      title:'Κόκκινος φάκελος',
      owned:'Οι φάκελοι μου ',
      amount:'Ποσό',
      quantity:'Ποσότητα ',
      quantity_hint:'Ποσότητα φακέλου ',
      generate:'Παράγω ',
      title2:'Αποστολή φακέλου ',
      total:'Κόκκινος φάκελος συνολικό ποσό ',
      wishes:'Ευχές ',
      submit:'Πληρωμή ',
      enter_pass:'Εισαγάγετε τον κωδικό πληρωμής ',
      choose_path:'Επιλέξτε μια μέθοδο παράδοσης ',
      view:'Προβολή λεπτομέρειας κόκκινου φακέλου ',
      choose_coin:'Επιλέξτε νόμισμα ',
      need_pay_password:'Ορίστε πρώτα τον κωδικό πληρωμής ',
      share:'Μοιραστείτε τον κόκκινο φάκελο με τους φίλους σας ',
      title3:'Εγγραφές κόκκινου φακέλου ',
      num:'Ποσότητα ',
    },
    mnemonic:{
      title:'εφεδρικό πορτοφόλι μνημονικός',
      tip:'Το μνημονικό είναι το ιδιωτικό κλειδί, το οποίο είναι το κλειδί για τον έλεγχο της περιουσίας σας ',
      tip1:'1. Αποτελείται από 12 χαρακτήρες, παρακαλούμε αντιγράψτε το και φυλάξτε το σε ασφαλές μέρος. ',
      tip2:'2. Το 100% θα κρατηθεί από εσάς, αφού χαθεί, δεν μπορεί να ανακτηθεί. ',
      tip3:'3. Φροντίστε να συμπληρώσετε το αντίγραφο ασφαλείας της μνημονικής φράσης πριν λάβετε το νόμισμα ή απεγκαταστήσετε το νόμισμα. ',
      backup:'Δημιουργία αντιγράφων ασφαλείας τώρα ',
      later:'Κάντε το αργότερα ',
      tip4:'Παρακαλώ κοιτάξτε γύρω σας ',
      tip5:'Όποιος παίρνει το μνημονικό σημαίνει ότι έχει πάρει τα περιουσιακά σας στοιχεία. Βεβαιωθείτε ότι δεν υπάρχει κανείς τριγύρω και δεν υπάρχουν κάμερες. ',
      understand:'Κατανοητό ',     
      title2:'Προβολή Μνημονικός',
      tip6:'Μπορείτε να εισαγάγετε τη μνημονική φράση για σύζευξη σε άλλες συσκευές ή να χρησιμοποιήσετε το πορτοφόλι AuWallet σε άλλες συσκευές για να σαρώσετε τον κωδικό QR για σύζευξη. ',
      tip7:'Παρακαλώ μην τραβήξετε στιγμιότυπο οθόνης! Αν κάποιος λάβει τη μνημονική σας φράση, θα πάρει απευθείας τα περιουσιακά σας στοιχεία! ',
      view_code:'Προβολή κρυπτογραφημένου κωδικού QR ',
      tip8:'Η κρυπτογράφηση του κωδικού QR διευκολύνει τη σύζευξη του πορτοφολιού με νέες συσκευές. Μην τραβάτε στιγμιότυπα οθόνης και μην τα αποθηκεύετε και βεβαιωθείτε ότι δεν υπάρχουν άλλα άτομα γύρω ή κρυφές κάμερες.',
      tip9:'Αυτός ο κωδικός QR μπορεί να χρησιμοποιηθεί μόνο από πορτοφόλια AU. Κατά τη σάρωση, πρέπει να εισαγάγετε τον κωδικό PIN της τρέχουσας APP στην APP που πρόκειται να εισαχθεί για να εισαγάγετε με επιτυχία το αντίστοιχο μνημονικό. ',
  
      title3:'Αντιγράψτε το μνημονικό AuWallet ',
      tip3_1:'Η μνημονική φράση AuWallet χρησιμοποιείται για την επαναφορά του πορτοφολιού. Αντιγράψτε τις παρακάτω 12 λέξεις σε χαρτί με τη σειρά και αποθηκεύστε τις σε ασφαλές μέρος. ',
      tip3_2:'Παρακαλώ μην τραβήξετε στιγμιότυπο οθόνης! Αν κάποιος λάβει τη μνημονική σας φράση, θα πάρει απευθείας τα περιουσιακά σας στοιχεία! ',
      save:'Το έχω αποθηκεύσει με ασφάλεια ',
  
      title4:'Επιβεβαιώστε τη μνημονική φράση AuWallet ',
      tip4_1:'Για να βεβαιωθείτε ότι έχετε αντιγράψει σωστά τις μνημονικές λέξεις του AuWallet, επιλέξτε τη λέξη που αντιστοιχεί στον σειριακό αριθμό. ',
      finish:'Φινίρισμα ',
      next:'Επόμενο',
      verror:'Σφάλμα επικύρωσης ',
  
      title5:'Επαναφέρετε το Μνημονικό Πορτοφόλι ',
      tip5_1:'Εισαγάγετε τις μνημονικές λέξεις στην παρακάτω φόρμα για να απαντήσετε στο πορτοφόλι. Μετά την εισαγωγή κάθε μνημονικής λέξης, πατήστε το πλήκτρο "space" για να μεταβείτε στην επόμενη λέξη ',
      recover:'Ξεκινήστε την αποκατάσταση',
      ask:'Αντικατάσταση του τρέχοντος πορτοφολιού;',
      tip5_2:"Η εισαγωγή ενός πορτοφολιού θα αντικαταστήσει το τρέχον πορτοφόλι. Εάν δεν έχετε δημιουργήσει ακόμα αντίγραφα ασφαλείας, το τρέχον πορτοφόλι θα εξαφανιστεί για πάντα. ",
      tip5_3:'Έχω δημιουργήσει αντίγραφα ασφαλείας του τρέχοντος πορτοφολιού μου και συμφωνώ να το αντικαταστήσω ',
      cancel:'Ματαίωση',
      import:'Συνεχίστε την εισαγωγή ',
      agree:'Επιλέξτε να συμφωνήσετε ',
      create_success:'Δημιουργήθηκε με επιτυχία ',
      complete:'Παρακαλώ συμπληρώστε το πλήρες μνημονικό',
    },
    invite:{
      title:'Η πρόσκλησή μου',
      total:'Αριθμός πρόσκλησης',
      invite_num:'Αριθμός εγγεγραμμένων φίλων',
      bonus1:'Φίλοι 1 επιπέδου',
      every:'ανά άτομο',
      bonus2:'Φίλοι 2 επιπέδων',
      bonus3:'Φίλοι 3 επιπέδων',
      deposit:'Αριθμός φίλων που καταθέτουν νομίσματα',
      list:'Λίστα προσκλήσεων',
      subtitle1:'Εγγραφή',
      subtitle2:'Κατάθεση',
      no_records:'Δεν υπάρχει ακόμη πρόσκληση'
    },
    lang:{
      set_lang:'Ορισμός γλώσσας',

    },
    setting:{
      tip:'Το σύστημα διαπραγματεύεται στην πραγματικότητα σε δολάρια ΗΠΑ και το σύστημα μετατρέπει αυτόματα την τιμή προμήθειας του χρήστη σε δολάρια ΗΠΑ με την πιο πρόσφατη συναλλαγματική ισοτιμία. Η πραγματική τιμή προμήθειας μπορεί να είναι ελαφρώς διαφορετική από την τιμή εισόδου του χρήστη'
    },
    send:{
      title:'Τύπος μεταφοράς',
      t1:'Μεταφορά Blockchain',
      t2:'Εσωτερική μεταφορά',
    },
    sortable:{
      title:'Προσαρμοσμένη ταξινόμηση',
      drag_to_sort:'Σύρετε για ταξινόμηση',
      currency:'Νόμισμα'
    },
    system:{
      flushing:'Έξαψη...',
      loading:'Φόρτωση...',
      btn1:'Επιβεβαιώνω',
      btn2:'Ματαίωση',
      add:'Προσθήκη',
      search:'Αναζήτηση',
      topPullText:'Τραβήξτε προς τα κάτω για ανανέωση',
      topDropText:'Απελευθερώστε την ανανέωση',
      topLoadingText:'Φόρτωση...',
      copy_succ:'Αντιγραφή με επιτυχία',
      copy_fail:'Η αντιγραφή απέτυχε',
      about:'About'
    },
    share:{
      title:'Μερίδιο ',
      download:'Σάρωση κώδικα για λήψη του AuWallet ',
      sharecode:'Κωδικός πρόσκλησης (κάντε κλικ για αντιγραφή): ',
      view_invites:'Προβολή λεπτομερειών πρόσκλησης ',
      copy_link:'Αντιγραφή συνδέσμου',
      attention:'Αντιγράψτε τον παραπάνω σύνδεσμο, επικολλήστε τον στο πρόγραμμα περιήγησης του κινητού σας και ανοίξτε τον για λήψη του πορτοφολιού Au.'
    },
    wealth:{
      tit:"Περιουσιακά στοιχεία",
      title:'Ο πλούτος μου',
      title1:'Εξόρυξη',
      title2:'Σχέδιο νομισμάτων',
      hot:'Λαϊκή σύσταση',
      plan1:'Σχέδιο κατά παραγγελία',
      plan2:'Σταθερό σχέδιο',
      annu_return:'ετήσια απόδοση',
      in_amount:'ποσό σε',
      transfer_all:'όλα',
      view_rules:'προβολή κανόνων',
      pay_password:'Εισαγάγετε τον κωδικό πληρωμής',
      asset:'Πλούτος',
      search:'Έρευνα συναλλαγής',
      rules:'κανόνες',
      order_time:'ώρα παραγγελίας',
      value_date:'ημερομηνία αξίας',
      expiry_date:'ημερομηνία λήξης',
      highlights:'καλύτερες στιγμές',
      remaining_quota:'υπόλοιπο ποσόστωσης',
      buy:'Αγορασε τωρα',
      ystday_earnings:"τα χθεσινά κέρδη",
      total_earnings:'συνολικες αποδοχες',
      transfer_in:'σε',
      transfer_out:'έξω',
	  transfer_outed:'Λύτρωση',
      tran_all:'όλα',
      tran_in:'σε',
      tran_out:'έξω',
      tran_earning:'αποκτήσουν εισόδημα',
      prod_all:'όλα',
      prod1:'Εξόρυξη PoS',
      prod2:'Σχέδιο νομισμάτων',
      curr_all:'όλα',
      out_amount_tip:'Εισαγάγετε το ποσό μεταφοράς',
      send:'Στείλετε',
      success:'επιτυχία',
      amount_tip:'Εισαγάγετε ένα ποσό'
    },
    ads:{
      title:'Καλα ΝΕΑ',
      content:'U2U εξαγοράζεται',
      content2:'2UT Hot selling...',
      buy:'αγορά',
      plan_name:'U2U Νέο τεύχος',
      tip: 'U2U is 10% off!'
  
    },
    buyuut: {
      maxtip: 'Each person can buy a maximum of 100',
      current: 'Current',
      price: 'Price',
      discount: 'Discount',
      off: 'OFF',
      amountlabel: 'Purchase quantity',
      maxerror: 'You can\'t buy more than 100',
      totalprice: 'Total Price',
      balance: 'Balance',
      purchase: 'Purchase',
      rulestitle: 'Rules of Activity'
    },
	  receive:{
		  fuzhicg:'Αντιγραφή επιτυχής.',
		  fuzhicc:'Αποτυχία αντιγραφής.',
	  },
	  alert:{
	  	  cancel:'ακύρωση',
	  	  confirm:'επιβεβαίωση'
	  },
  against:{
		  no100: 'Το Usdt πρέπει να είναι πολλαπλάσιο των 100'
	},
	package:{
		  title: 'Συσκευασία',
		  amount: 'Ποσό',
		  time: 'Χρόνος',
		  coin: 'Token',
		  price: 'Τιμή',
		  scale: 'Κλίμακα',
		  quantity: 'Ποσότητα',
		  submit: 'Υποβολή',
		  total: 'Σύνολο',
		  points: 'Σημείο',
		  apoints2: 'Διαθέσιμα έσοδα πλούτου',
		  balance: 'Ισορροπία',
		  apoints: 'Διαθέσιμα σημεία:',
		  abalance: 'Διαθέσιμο υπόλοιπο(USDT):',
		  abalance2: 'Διαθέσιμο υπόλοιπο(U2U):',
		  import: 'Εισαγωγή',
		  orders: 'Διατάξεις',
		  orders_detail: 'Λεπτομέρεια παραγγελίας',
		  defi: 'DEFI',
		  nopoint: 'Εξαργυρώστε περισσότερους από τους διαθέσιμους πόντους',
		  nobalance: 'Η εξόφληση υπερβαίνει το διαθέσιμο υπόλοιπο',
		  nologin: 'Η σύνδεση έληξε, παρακαλώ συνδεθείτε ξανά.',
		  pay_type: 'Τύπος πληρωμής'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
  }
  